import Select from "../../../../../../common/StyledSelect";
import { withStyles } from "@material-ui/core";
import WithRowLabel from "./WithRowLabel";

const styles = () => ({
  root: {
    margin: 0,
  },
  input: {
    padding: "2px 0px",
  },
  label: {
    transform: `translate(14px, 10px) scale(1)`,
  },
  menuItem : {
    whiteSpace : "unset"
  }
});

const StyledSelect = withStyles(styles)(Select);
const SelectWithLabel = WithRowLabel(StyledSelect);
export { StyledSelect, SelectWithLabel };
